import React, { useEffect, useState, useContext } from "react";
import "./Gallery.css";
import axios from "axios";
import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Gallery = () => {
  const { currentLang } = useContext(LanguageContext);
  const [gallery, setGallery] = useState(null);
  const [loading, setLoading] = useState(true);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${API_BASE}/api/GallerySection?lang=${currentLang}`
        );
        setGallery(res.data);
      } catch (err) {
        console.error("Error fetching gallery section:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, [currentLang]);

  if (loading) return <div className="gallery-loading">Loading...</div>;
  if (!gallery) return <div className="gallery-error">No gallery data found.</div>;

  const upImageUrl = resolveUrl(gallery.upImageUrl);
  const downImageUrl = resolveUrl(gallery.downImageUrl);

  return (
    <div className="gallery">
      <div className="gallery-up">
        <div className="gallery-up-img">
          <img
            src={upImageUrl}
            alt={gallery.upTitle || "Gallery image"}
            className="guic"
            style={{ width: "100%", height: "auto" }}
          />
        </div>
        <div className="gallery-up-text">
          <h1>{gallery.upTitle}</h1>
          <p>{gallery.upDescription}</p>
        </div>
      </div>

      <div className="gallery-down">
        <div className="gallery-down-text">
          <h1>{gallery.downTitle}</h1>
          <p>{gallery.downDescription}</p>
        </div>
        <div className="gallery-down-img">
          <img
            src={downImageUrl}
            alt={gallery.downTitle || "Gallery image"}
            className="gdic"
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Gallery;
